import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const Register = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login since registration is only available through admin
    navigate('/login');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <p className="text-slate-600">Redirecting to login...</p>
      </div>
    </div>
  );
};